/**
 * DEFLATE for the `l2Payload` plaintext, applied between signing and encrypting. A copy of
 * `compressPayload` in packages/sdk/src/crypto.ts (the dex doesn't depend on @sugar-rush/sdk);
 * read back by `AppState::inflate_if_compressed`. See the SDK original for the framing and
 * why-it-pays rationale. Keep the two in sync.
 */
import { deflateSync } from "fflate";

/** First byte of a compressed plaintext; uncompressed payloads are JSON (open with `{`, 0x7B), so
 * the forms can't be confused. See crypto.ts. */
const COMPRESSED_DEFLATE = 0x01;

/** Compress the payload JSON unless that would expand it (then send plain JSON, which the server
 * understands). Rationale and measurements: the SDK copy. */
export function compressPayload(json: Uint8Array): Uint8Array {
  const deflated = deflateSync(json, { level: 6 });
  if (deflated.length + 1 >= json.length) return json;
  const out = new Uint8Array(deflated.length + 1);
  out[0] = COMPRESSED_DEFLATE;
  out.set(deflated, 1);
  return out;
}
